module.exports = __webpack_public_path__ + "static/img/m_name.70817ea.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/swbnzk/m_name.png
// module id = lBtt
// module chunks = 7